import { AbstractControlOptions, FormControl, ValidatorFn } from "@angular/forms";

export class EformControl extends FormControl {
    prefixEform: string;
    idInput: string;
    type: string;
  
    constructor(_prefixEform?: string, _idInput?: string, _type?: string, formState?: any, validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions) {
      super(formState, validatorOrOpts);
      this.prefixEform = _prefixEform;
      this.idInput = _prefixEform + '|' + _idInput;
      this.type = _type;
    }
    
  }